interface NtpDate {
  id: string;
  it: number;
  st: number;
  leap: number;
  next: number;
  step: number;
}

export const getTime = async () => {
  if (typeof window !== "undefined") {
    const serverList = ["https://datetime.comics.gendaibusiness.com/json"];
    const serverUrl = serverList[Math.floor(Math.random() * serverList.length)];
    const timeDefaultValue = 1;
    let time = timeDefaultValue;
    try {
      const res: NtpDate = await fetch(serverUrl).then(data => {
        return data.json();
      });
      time = parseInt(res.st.toString().replace(".", ""));
    } catch (e) {
      //
    }
    if (time === timeDefaultValue) {
      // TODO: リトライ処理必要
      time = new Date().getTime();
    }
    return time;
  } else {
    return new Date().getTime();
  }
};
